import { ResourceModel } from "src/app/core/models/resource.model";

export class Rds extends ResourceModel<Rds> {
    status!: boolean;
    namespace!: string;
    id!: string;
    email!: string;
    domain!:string;
    plan!: string;
    appclaim!: string;
    parameters!: any;
    DBInstanceStatus!: string;
    DBName!: string;
    DBInstanceIdentifier!: string;
    DBInstanceArn!: string;
    AvailabilityZone!: string;
}